import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { PLATFORM_DISPLAY_NAMES } from 'constants/platforms-display-props';

export const defaultTranslationKeyOptions = {
    gameName: 'gameName'
};

export enum MODIFIED_TRANSLATION_KEYS_OPTION_NAMES {
    PLATFORM = 'platform'
}

export const MODIFIED_TRANSLATION_KEYS_OPTIONS: { [key in string]: { [key2 in string]: string }} = {
    [MODIFIED_TRANSLATION_KEYS_OPTION_NAMES.PLATFORM]: {
        [PLATFORM_TYPES.XONE]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.XONE],
        [PLATFORM_TYPES.XSX]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.XSX]
    }
};
